import { $host,$authHost } from "."

export const fetchAll = async () => {
    const {data} = await $host.get('/brick')
    console.log(data);
    
    return data
}
export const fetchOne = async (id) => {
    const {data} = await $host.get(`/brick/${id}`)
    return data
}
export const createBrick = async (formData) => {
    const { data } = await $authHost.post('/brick/add', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return data;
}
export const deleteBrick = async (id) => {
    const {data} = await $authHost.delete(`/brick/${id}`)
    return data
}
export const updateBrick = async (id, formData) => {
    const {data} = await $authHost.put(`/brick/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return data;
}